import { render, staticRenderFns } from "./RiskView.vue?vue&type=template&id=44dca093&scoped=true"
import script from "./RiskView.vue?vue&type=script&lang=js"
export * from "./RiskView.vue?vue&type=script&lang=js"
import style0 from "./RiskView.vue?vue&type=style&index=0&id=44dca093&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dca093",
  null
  
)

export default component.exports